import { useState } from "react";
import { toast } from "sonner";

interface ShareData {
  title: string;
  description?: string;
  price: number;
  imageUrl?: string;
  shareableLink: string;
  businessName?: string;
}

// Share subdomain for WhatsApp previews - hosted on Netlify
// This subdomain serves OG metadata for crawlers and redirects users to main site
const SHARE_DOMAIN = "https://share.sabitradeng.com";

export function useWhatsAppShare() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [shareData, setShareData] = useState<ShareData | null>(null);

  /**
   * Creates a shareable link using the main domain.
   * Format: https://sabitradeng.com/share/product/{productId}
   * - Crawlers get OG meta tags via Netlify edge function
   * - Users are redirected to checkout flow
   */
  const createShareableLink = (productId: string, checkout = true) => {
    // Use share subdomain which has OG metadata for WhatsApp previews
    const url = `${SHARE_DOMAIN}/${productId}`;
    return checkout ? `${url}?checkout=true` : url;
  };

  const share = async (data: ShareData) => {
    setShareData(data);

    // Just share the link - WhatsApp will fetch OG tags for rich preview
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(data.shareableLink)}`;
    window.open(whatsappUrl, "_blank");

    toast.success("WhatsApp opened");
  };

  return {
    share,
    createShareableLink,
    isDialogOpen,
    setIsDialogOpen,
    shareData,
  };
}

// Backward compatibility
export function createDMMessage(data: ShareData): string {
  return data.shareableLink;
}
